<template>
<div>
<section class="login-area" id="login" >
  <div class="text-part">
<div class="container-login-area-first">
  <div class="login-grid-one">
    <p class="text-login-area-one" >Please log in to start using</p>
    <h1 class="text-login-area-two">Booked Tool</h1>
  </div>
  <div class="login-grid-two">
     <form>
      <div class="container-login-area">
      <input class="input-login-area" type="text" name="" placeholder="Email" >
      <input class="input-login-area" type="password" name="" placeholder="Password">
      <input class="button-login-area" type="submit" name="" value="Login">
      </div>
    </form>
  </div>
</div>
  </div>
</section>
</div>
</template>


<script>
import "../styles/Loginsection.scss"

export default {
    name: "Loginsection"
}
</script>